import {
  Box,
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Skeleton,
  Stack,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { AiOutlineHome } from "react-icons/ai";
import { setDrawer } from "../../../app/slices/appSlice";
import { SidebarBrand, navItemSx } from "../../MainLayout/Sidebar";

const drawerWidth = 220;

const links = [
  {
    name: "الفواتير",
    icon: <AiOutlineHome size={18} />,
    path: "/pos/external-orders",
  },
];

// Sidebar of the POS dashboard; same look as the admin sidebar.
const PosSideBar = () => {
  const userInfoLoading = useSelector((state) => state.user.userInfoLoading);
  const drawerOpen = useSelector((state) => state.app.is_drawer_opened);
  const theme = useTheme();
  const matchUpMd = useMediaQuery(theme.breakpoints.up("md"));
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (
    <Box
      component="nav"
      sx={{ flexShrink: { md: 0 }, width: matchUpMd ? drawerWidth : "auto" }}
      aria-label="sidebar"
    >
      <Drawer
        dir="rtl"
        variant={matchUpMd ? "persistent" : "temporary"}
        anchor="left"
        open={drawerOpen}
        onClose={() => dispatch(setDrawer())}
        sx={{
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            borderRight: "1px solid #eaecf0",
          },
        }}
        ModalProps={{ keepMounted: true }}
      >
        <SidebarBrand subtitle="نقاط البيع" />
        {userInfoLoading ? (
          <Stack spacing={1.5} sx={{ m: 2 }}>
            {Array.from({ length: 4 }, (_, i) => (
              <Skeleton key={i} variant="rounded" height={32} />
            ))}
          </Stack>
        ) : (
          <List sx={{ py: 1.5, px: 1.25 }}>
            {links.map((item) => (
              <ListItemButton
                key={item.path}
                selected={pathname.startsWith(item.path)}
                onClick={() => navigate(item.path)}
                sx={navItemSx}
              >
                <ListItemIcon>{item.icon}</ListItemIcon>
                <ListItemText
                  primary={item.name}
                  primaryTypographyProps={{
                    fontSize: "0.82rem",
                    fontWeight: "inherit",
                  }}
                />
              </ListItemButton>
            ))}
          </List>
        )}
      </Drawer>
    </Box>
  );
};

export default PosSideBar;
